<template>
  <VCheckbox
    :id="String(category.id)"
    class="form__item form-checkbox form--double-item"
    :name="category.name ? category.name : 'temporary'"
    class-label="label label-border">
    <template #default="slotProps">
      <label :for="slotProps.for" :class="slotProps.class">
        {{ category.name }}
      </label>
    </template>
  </VCheckbox>
</template>

<script>
import VCheckbox from '@/components/ui/form/Checkbox/VCheckbox'
export default {
  components: {
    VCheckbox,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
}
</script>
